export default function WhyUs() {
  const reasons = [
    {
      icon: 'ri-focus-3-line',
      title: '效果导向，拒绝花哨',
      description: '我们只关心一件事：您的客服效果有没有变好',
      details: [
        '以结果为目标持续优化',
        '每次质检都为提升下一次效果',
        '数据、分析、改进形成闭环',
      ],
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '强服务交付，拒绝复杂',
      description: '不把"能力"当成"产品"，我们提供的是服务',
      details: [
        '客户只需提供知识资料，其余我们完成',
        '提供知识清洗、结构化与数据增强',
        '运营专员全程跟进上线与优化',
      ],
    },
    {
      icon: 'ri-robot-line',
      title: '解决问题，拒绝闲聊',
      description: '从"能答"到"能解决"，专为解决问题而生',
      details: [
        '自研客服行业解决问题模型',
        '源自真实业务场景打磨，持续优化',
        '不做脱离场景的"演示型 AI"',
      ],
    },
    {
      icon: 'ri-refresh-line',
      title: '持续进化，拒绝一次性',
      description: '很多系统能用，但很快就不行了',
      details: [
        '每次对话都会反向优化系统',
        '知识、策略与效果不断迭代进化',
        '客服系统与业务一起成长',
      ],
    },
    {
      icon: 'ri-line-chart-line',
      title: '洞察增长，不只看指标',
      description: '数据洞察从第一天开始，就不只是报表设计',
      details: [
        '不只看响应时长与会话量',
        '识别真实客户需求与潜在机会',
        '支持产品与业务决策',
      ],
    },
    {
      icon: 'ri-stack-line',
      title: '平台拓展，不止于客服',
      description: '从客服开始，但不止于客服',
      details: [
        '内置 AI 质检与知识学习能力',
        '提供数据洞察与运营分析',
        '支持更多业务智能能力拓展',
      ],
    },
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-white to-[#f8fbff]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-14 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            为什么选择<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0066ff] to-[#7c5cfc]">火花派</span>？
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 md:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={`reason-${index}`}
              className="group relative bg-white/80 backdrop-blur-sm border-2 border-gray-100 rounded-2xl p-6 sm:p-7 md:p-8 hover:border-[#0066ff]/30 hover:shadow-2xl transition-all hover:-translate-y-2 flex flex-col h-full"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#0066ff]/10 to-[#7c5cfc]/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative flex flex-col h-full">
                <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-6">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex-shrink-0 flex items-center justify-center bg-gradient-to-br from-[#0066ff] to-[#00a3ff] rounded-xl group-hover:scale-110 transition-transform shadow-lg">
                    <span className="text-lg sm:text-xl font-bold text-white">{index + 1}</span>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight">{reason.title}</h3>
                </div>
                <ul className="space-y-1.5 sm:space-y-2 flex-grow">
                  {reason.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-[#0066ff] mt-1 flex-shrink-0">•</span>
                      <span className="text-xs sm:text-sm text-gray-600 leading-relaxed">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
